var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.formContainer},[(_vm.error)?_c('div',{class:_vm.$style.buttonHolder},[_c('AppButton',{attrs:{"on-click":function () { return _vm.startIdentification(); }}},[_vm._v(" "+_vm._s(_vm.$t('try-again'))+" ")])],1):_vm._e(),_c('div',{ref:"iframeHolder",class:[_vm.$style.iframeHolder, ( _obj = {}, _obj[_vm.$style.hidden] = _vm.error, _obj )]})])}
var staticRenderFns = []

export { render, staticRenderFns }